// eslint-disable-next-line no-useless-escape
export const loginPatt = /^(?:[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*)(?!.)/;

// eslint-disable-next-line no-useless-escape
export const passwordPatt = /^(?=.*[a-zA-z0-9_а-яА-я])(?=.{6,})/;
